// Import the Tailwind base styles
// import "./src/styles/index.scss"
import "tailwindcss/dist/base.css"
